// extracted by mini-css-extract-plugin
module.exports = {"a":"F-docs-heading-a-3UCml","hashtag":"F-docs-heading-hashtag-34o58"};